// Dependencies
import React from 'react';
import radium from 'radium';
import Checkbox from "../../../components/checkbox/Checkbox.tsx";
import LeoHint from "../../../components/hint/LeoHint";
import {ThemeContext} from "../../../components/theme/Theme.jsx";

function MarketingApproval(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		checkbox: {
			margin: '0 0 1.3em 0',
			justifyContent: 'flex-start',
			display: 'flex',
		},
		label: {
			display: 'flex',
			alignItems: 'baseline',
		},
	}
	return (
		<Checkbox
			name="marketingApproval"
			value="MARKETING_APPROVAL"
			onChange={(event)=>props.onMarketingApprovalChange(event.target.checked)}
			checked={props.marketingApproval}
			label={
				<span style={style.label}>
										{context.themeManager.getThemeTextOrHardcodedDefault('marketingApprovalCheckboxLabel')}
					{(context.themeManager.getThemeTextOrHardcodedDefault('marketingCampaignPopupText')) &&
					<LeoHint
						leoHintContainerStyle={{ marginTop: '0em', alignItems: 'baseline' }}
						hintText=""
						popupHeadline={context.themeManager.getThemeTextOrHardcodedDefault('marketingCampaignPopupTitle')}
						popupText={context.themeManager.getThemeTextOrHardcodedDefault('marketingCampaignPopupText')}
					/>}
									</span>
			}
			style={style.checkbox}
		/>
	);
}

export default radium(MarketingApproval)
